/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { analyticsCampaignAnalytics } from '../../axios/analyticsCampaignAnalytics'
import type {
	AnalyticsCampaignAnalyticsError,
	AnalyticsCampaignAnalyticsPathParams,
	AnalyticsCampaignAnalyticsResponse,
} from '../../types/AnalyticsCampaignAnalytics'

export const analyticsCampaignAnalyticsQueryKey = (campaign: AnalyticsCampaignAnalyticsPathParams['campaign']) =>
	[{ url: '/campaigns/:campaign/analytics', params: { campaign } }] as const

export type AnalyticsCampaignAnalyticsQueryKey = ReturnType<typeof analyticsCampaignAnalyticsQueryKey>

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::campaignAnalytics */
export function analyticsCampaignAnalyticsQueryOptions(
	campaign: AnalyticsCampaignAnalyticsPathParams['campaign'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		AnalyticsCampaignAnalyticsResponse,
		AxiosError<AnalyticsCampaignAnalyticsError>,
		AnalyticsCampaignAnalyticsResponse,
		AnalyticsCampaignAnalyticsQueryKey
	>({
		queryKey: analyticsCampaignAnalyticsQueryKey(campaign),
		queryFn: ({ signal }) => analyticsCampaignAnalytics(campaign, { signal, ...config }).then(res => res.data),
		enabled: !!campaign,
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::campaignAnalytics */
export function useAnalyticsCampaignAnalytics<TSelectData = AnalyticsCampaignAnalyticsResponse>(
	campaign: AnalyticsCampaignAnalyticsPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					AnalyticsCampaignAnalyticsResponse,
					AxiosError<AnalyticsCampaignAnalyticsError>,
					TSelectData,
					AnalyticsCampaignAnalyticsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<AnalyticsCampaignAnalyticsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...analyticsCampaignAnalyticsQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::campaignAnalytics */
export function useAnalyticsCampaignAnalyticsSuspense<TSelectData = AnalyticsCampaignAnalyticsResponse>(
	campaign: AnalyticsCampaignAnalyticsPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					AnalyticsCampaignAnalyticsResponse,
					AxiosError<AnalyticsCampaignAnalyticsError>,
					TSelectData,
					AnalyticsCampaignAnalyticsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<AnalyticsCampaignAnalyticsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...analyticsCampaignAnalyticsQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
